import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-conditions',
  templateUrl: './conditions.component.html',
  standalone: true,
  imports: [TranslateModule],
})
export class ConditionsComponent {}
